import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CaseStudyPage.css';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';
import { caseStudies as caseStudiesData, caseStudyPlaceholders } from './data/caseStudies';

// 文中の数字（改善率・件数など）を等幅書体にする
const NUMBER_PATTERN = /(\d[\d.,]*(?:[〜~]\d[\d.,]*)?)/;

function withNumbers(text) {
  return text.split(NUMBER_PATTERN).map((part, i) =>
    i % 2 === 1 ? <span key={i} className="ds-num">{part}</span> : part
  );
}

function CaseStudyPage() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: '導入事例', path: '/case-studies' }
  ];

  const caseStudies = caseStudiesData;

  // ページ遷移時に最上部にスクロール
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <SEO page="caseStudies" />

      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">CASE STUDY</p>
          <h1 className="ds-h1">導入事例インタビュー</h1>
          <p className="ds-lead">
            OSUMITSUKIを導入いただいている企業様に、導入の経緯や効果についてお話を伺いました。
          </p>
        </div>
      </section>

      <section className="ds-section">
        <div className="container">
          <ul className="csp-grid">
            {caseStudies.map((caseStudy) => (
              <li key={caseStudy.id}>
                <Link to={`/case-study/${caseStudy.id}`} className="ds-card csp-card">
                  <div className="csp-card-image">
                    <img src={caseStudy.imageUrl} alt={`${caseStudy.companyName}の事例`} />
                  </div>
                  <div className="csp-card-body">
                    <p className="csp-card-no ds-num">CASE {caseStudy.id.padStart(2, '0')}</p>
                    <h2 className="ds-h3 csp-card-title">{caseStudy.companyName}</h2>
                    <p className="csp-card-summary">{withNumbers(caseStudy.summary)}</p>
                    {caseStudy.tags && caseStudy.tags.length > 0 && (
                      <ul className="csp-card-tags">
                        {caseStudy.tags.map((tag) => (
                          <li key={tag} className="ds-tag">{tag}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </Link>
              </li>
            ))}
            {Array.from({ length: caseStudyPlaceholders }).map((_, idx) => (
              <li key={`placeholder-${idx}`}>
                <div className="ds-card csp-card csp-card--placeholder">
                  <div className="csp-card-image" />
                  <div className="csp-card-body">
                    <p className="csp-card-summary">近日公開の事例</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {/* 問い合わせボタン */}
          <div className="csp-contact">
            <Link to="/contact" className="ds-btn ds-btn--primary ds-btn--arrow">
              お問い合わせはこちら
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CaseStudyPage;
